import { render, staticRenderFns } from "./PublicProfileLink.vue?vue&type=template&id=03c003d9&"
import script from "./PublicProfileLink.vue?vue&type=script&lang=js&"
export * from "./PublicProfileLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c003d9')) {
      api.createRecord('03c003d9', component.options)
    } else {
      api.reload('03c003d9', component.options)
    }
    module.hot.accept("./PublicProfileLink.vue?vue&type=template&id=03c003d9&", function () {
      api.rerender('03c003d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/PublicProfileLink.vue"
export default component.exports